import styles from "./Timer.module.scss";
import {formatRemainingTime} from "../utils/timer.utils";
import timerIconRiize from "../assets/images/riize/timer_icon_riize.png";
import timerIconAespa from "../assets/images/aespa/timer_icon_aespa.png";
import timerWarnIcon from "../assets/images/common/timer_warn_icon.png";
import {ARTIST, Artist} from "src/utils/artist.utils";

type TimerProps = {
  artist: Artist;
  remainingSeconds: number;
  format?: "h:mm:ss" | "mm:ss";
  warningThresholdSeconds?: number;
};

const Timer = ({
  artist,
  remainingSeconds,
  format = "h:mm:ss",
  warningThresholdSeconds,
}: TimerProps) => {
  const isWarning =
    warningThresholdSeconds !== undefined &&
    remainingSeconds <= warningThresholdSeconds;

  return (
    <div
      className={`${styles.timer} ${artist} ${isWarning ? styles.warning : ""}`}
    >
      <div className={styles.iconWrapper}>
        <img
          src={
            isWarning
              ? timerWarnIcon
              : artist === ARTIST.aespa
                ? timerIconAespa
                : timerIconRiize
          }
          alt="timer"
          className={styles.icon}
        />
      </div>
      <span className={`${styles.text} ${artist}`}>
        {formatRemainingTime(remainingSeconds, format)}
      </span>
    </div>
  );
};

export default Timer;
